import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { obtenerClientes, eliminarCliente } from '../../servicios/api'; // Importar eliminarCliente

const ListaClientes = ({ onVolver, onNuevoCliente }) => {
    const [clientes, setClientes] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    // Función para cargar o recargar los clientes
    const cargarClientes = async () => {
        try {
            setIsLoading(true);
            const respuesta = await obtenerClientes();
            if (respuesta.exito) {
                setClientes(respuesta.clientes);
            } else {
                setError(respuesta.mensaje);
            }
        } catch (err) {
            setError('No se pudo conectar con el servidor para obtener los clientes.');
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        cargarClientes();
    }, []);

    const handleShowNotes = (noteText) => {
        alert('NOTA PRIVADA (Solo visible internamente):\n\n' + (noteText || 'No hay notas para este cliente.'));
    };

    // Función para manejar la eliminación de un cliente
    const handleDelete = async (idCliente) => {
        if (window.confirm('¿Estás seguro de que quieres eliminar este cliente? Esta acción no se puede deshacer.')) {
            try {
                const respuesta = await eliminarCliente(idCliente);
                if (respuesta.exito) {
                    alert(respuesta.mensaje);
                    // Actualizar la lista de clientes en el estado para reflejar el cambio
                    setClientes(clientes.filter(c => c.id_cliente !== idCliente));
                } else {
                    // Mostrar error específico de la API (ej. cliente con facturas)
                    alert(`Error: ${respuesta.mensaje}`);
                }
            } catch (err) {
                const errorMsg = err.response?.data?.mensaje || 'Error de conexión al intentar eliminar.';
                alert(`Error: ${errorMsg}`);
                console.error(err);
            }
        }
    };

    return (
        <section>
            <div className="flex justify-between items-center mb-8 pb-4 border-b-2 border-[#ee6e3b]">
                <h2 className="text-3xl font-bold text-black">Lista de Clientes</h2>
                {onVolver && (
                     <button onClick={onVolver} className="bg-black text-white px-5 py-2.5 rounded-md text-sm font-semibold hover:bg-gray-800 transition-colors">
                        &larr; Volver
                    </button>
                )}
            </div>

            <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
                <span className="text-sm text-gray-600">Mostrando {clientes.length} de {clientes.length} clientes</span>
                <div className="flex gap-2">
                    <button className="bg-black text-white px-4 py-2 rounded-md text-sm font-semibold hover:bg-gray-800">Exportar</button>
                    <button onClick={onNuevoCliente} className="bg-[#ee6e3b] text-white px-4 py-2 rounded-md text-sm font-semibold hover:bg-[#d96233]">
                        + Nuevo Cliente
                    </button>
                </div>
            </div>

            <div className="overflow-x-auto shadow-md rounded-lg">
                <table className="w-full text-sm text-left text-gray-700">
                    <thead className="bg-black text-white text-xs uppercase">
                        <tr>
                            <th scope="col" className="px-6 py-3">Nombre</th>
                            <th scope="col" className="px-6 py-3">Email</th>
                            <th scope="col" className="px-6 py-3">Teléfono</th>
                            <th scope="col" className="px-6 py-3">NIF/NIE</th>
                            <th scope="col" className="px-6 py-3">Notas</th>
                            <th scope="col" className="px-6 py-3">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr><td colSpan="6" className="text-center p-4">Cargando clientes...</td></tr>
                        ) : error ? (
                            <tr><td colSpan="6" className="text-center p-4 text-red-500">{error}</td></tr>
                        ) : (
                            clientes.map((cliente) => (
                                <tr key={cliente.id_cliente} className="bg-white border-b hover:bg-gray-50">
                                    <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">{cliente.nombre_cliente}</td>
                                    <td className="px-6 py-4">{cliente.correo_electronico || 'N/A'}</td>
                                    <td className="px-6 py-4">{cliente.telefono || 'N/A'}</td>
                                    <td className="px-6 py-4">{cliente.nif || 'N/A'}</td>
                                    <td className="px-6 py-4 text-center">
                                        <button onClick={() => handleShowNotes(cliente.notas)} title="Ver notas privadas" className="hover:bg-[#ee6e3b] hover:text-white p-2 rounded-full transition-colors">
                                            📝
                                        </button>
                                    </td>
                                    <td className="px-6 py-4 flex items-center gap-2">
                                        <Link to={`/clientes/editar/${cliente.id_cliente}`} className="font-medium text-blue-600 hover:underline">✏️</Link>
                                        {/* Botón de eliminar con su nueva función */}
                                        <button onClick={() => handleDelete(cliente.id_cliente)} className="font-medium text-red-600 hover:underline">🗑️</button>
                                        <Link to={`/clientes/${cliente.id_cliente}`} className="font-medium text-green-600 hover:underline">👁️</Link>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Paginación (funcionalidad pendiente) */}
            <div className="flex justify-center items-center gap-2 mt-6">
                <button className="px-3 py-2 border border-gray-300 bg-white rounded-md text-sm hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed" disabled> &laquo; Anterior </button>
                <div className="flex gap-1">
                    <button className="px-4 py-2 border border-[#ee6e3b] bg-[#ee6e3b] text-white rounded-md text-sm">1</button>
                </div>
                <button className="px-3 py-2 border border-gray-300 bg-white rounded-md text-sm hover:bg-gray-100"> Siguiente &raquo; </button>
            </div>
        </section>
    );
};

export default ListaClientes;
